import { SlateElementType } from '@vedalib/rich-text'
import { isInlineElement } from '@vedalib/rich-text/lib/types/guards'
import { Editor, Element, Transforms } from 'slate'

import { ALL_RT_CONTROLS, LIST_ELEMENTS } from '../RichTextConstants'
import type { RichTextControl } from '../RichTextTypes'

export const withFeatureControl = (editor: Editor) => {
  const { insertFragment, normalizeNode } = editor

  editor.insertFragment = (data) => {
    insertFragment(data)
    Transforms.unwrapNodes(editor, {
      at: [],
      split: true,
      mode: 'all',
      match: (n) => {
        return (
          !Editor.isEditor(n) &&
          Element.isElement(n) &&
          isInlineElement(n) &&
          !ALL_RT_CONTROLS.includes(n.type as RichTextControl)
        )
      },
    })
  }

  if (!ALL_RT_CONTROLS.includes('blockElement')) {
    editor.normalizeNode = (entry) => {
      normalizeNode(entry)
      const [node, path] = entry
      if (Element.isElement(node) && LIST_ELEMENTS.includes(node.type)) {
        Transforms.unwrapNodes(editor, {
          at: path,
        })
      }

      if (Element.isElement(node) && node.type === SlateElementType.listItem) {
        Transforms.setNodes(editor, { type: SlateElementType.elementDefault }, { at: path })
      }
    }
  }

  return editor
}
